import { dashboardActivitySchema } from '@ghp/domain';
import { bearer } from './http.js';
import { queryString } from './query-string.js';
/** Le tableau de bord du back-office (R-B1) — ce qu'il lit à travers les domaines. */
export function createDashboardEndpoints(http) {
    return {
        /**
         * L'activité récente, **du plus récent au plus ancien** — dépôts de relevé, créneaux posés,
         * imports de fichier, validations. `clientId` absent ou `'all'` : tous les clients ; `limit`
         * absent : huit lignes, le serveur plafonnant à cinquante.
         */
        activity(accessToken, request = {}) {
            // `'all'` n'entre pas dans l'URL : c'est le défaut du serveur (cf. `statusCounts`).
            const { clientId, limit } = request;
            const query = queryString({ clientId: clientId === 'all' ? undefined : clientId, limit });
            return http.get(`/dashboard/activity${query}`, dashboardActivitySchema, bearer(accessToken));
        },
    };
}
//# sourceMappingURL=dashboard.js.map